import type { ChangeRequest } from '@/types';

/**
 * Whether `userId` may approve/reject this change request — mirrors the API's
 * authorization so the app never shows a button that would 403 silently (#5/#11).
 */
export function canApproveChange(cr: ChangeRequest, userId: number | undefined): boolean {
  if (userId === undefined) return false;
  // The API forbids the author from acting on their own request.
  if (cr.author_id === userId) return false;
  // Multi-approver mode: the user needs an own approval row still pending.
  if (cr.pending_approvals && cr.pending_approvals.length > 0) {
    return cr.pending_approvals.some((pa) => pa.approver_id === userId && pa.status === 'pending');
  }
  // Legacy single approver: unassigned → any (non-author) supervisor; else the
  // assigned approver only.
  if (!cr.assigned_approver_id) return true;
  return cr.assigned_approver_id === userId;
}
